import React from 'react';
import veterinario from '@/assets/images/veterinario.png';
import catshop from '@/assets/images/catshop.png';
import humanizado from '@/assets/images/humanizado.png';
import acolhedor from '@/assets/images/acolhedor.png';
import cuidado from '@/assets/images/cuidado.png';

const SobrePage = () => (
  <section className="about">
    <div className="container">
      <h2>Sobre Nós</h2>
        <div className="about-text">
          <p>
            Somos apaixonados por gatos e foi dessa paixão que nasceu A Casa dos Gatos. Desde sempre, sentimos na pele a dificuldade de encontrar um espaço realmente pensado para os felinos e seus tutores. Seja na busca por um brinquedo específico, um alimento de qualidade ou até mesmo um atendimento veterinário especializado, percebemos que o universo dos gatos ainda era tratado como secundário em muitos estabelecimentos.
            Foi então que unimos amor, experiência e um sonho antigo: criar um ambiente exclusivo para gatos. Nossa fundadora, médica veterinária com vasta experiência e dedicação à medicina felina, sempre teve o desejo de abrir uma clínica onde os bichanos fossem os protagonistas. Mas ela queria ir além: montar também uma loja completa, com uma curadoria especial de produtos pensados unicamente para o bem-estar dos gatos e o conforto de seus donos.
            Hoje, A Casa dos Gatos é esse espaço: um refúgio acolhedor e especializado, onde cada detalhe foi pensado para oferecer o melhor em saúde, bem-estar e qualidade de vida aos nossos queridos felinos. Aqui, você encontra atendimento veterinário dedicado exclusivamente aos gatos, além de uma catshop repleta de itens selecionados com carinho, variedade e qualidade.
            Se você ama gatos como a gente, esse é o seu lugar.
          </p>
          <div className="features">
            <div className="feature">
              <img src={veterinario} alt="Clínica Especializada" />
              <h3>Clínica Especializada</h3>
              <p>Atendimento exclusivo para felinos</p>
            </div>
            <div className="feature">
              <img src={catshop} alt="Catshop Completa" />
              <h3>Catshop Completa</h3>
              <p>Produtos selecionados para gatos</p>
            </div>
            <div className="feature">
              <img src={humanizado} alt="Cuidado Humanizado" />
              <h3>Cuidado Humanizado</h3>
              <p>Tratamento com carinho e respeito</p>
            </div>
            <div className="feature">
              <img src={acolhedor} alt="Ambiente acolhedor" />
              <h3>Ambiente acolhedor</h3>
              <p>Espaço confortável para os felinos</p>
            </div>
            <div className="feature">
              <img src={cuidado} alt="Gatos bem cuidados" />
              <h3>Gatos bem cuidados</h3>
              <p>Cuidado especial com cada gatinho</p>
            </div>
          </div>
        </div>
    </div>
  </section>
);

export default SobrePage;